import { render, staticRenderFns } from "./ReportedPosts.vue?vue&type=template&id=5c8469d0&"
import script from "./ReportedPosts.vue?vue&type=script&lang=js&"
export * from "./ReportedPosts.vue?vue&type=script&lang=js&"
import style0 from "./ReportedPosts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports